export default{
  namespaced: true,
  state:{
    requests: []
  },
  getters : {},
  mutations:{
    ADD_REQUEST_TO_LIST(state,data){
      state.requests = data
    }
  }
}
